import billingStatus from '@/utils/constants/billingStatus.js';
import billingStatusColor from '@/utils/constants/billingStatusColors.js';
import CertificationStatus from '@/utils/constants/CertificationStatus.js';
import CertificationStatusColors from '@/utils/constants/CertificationStatusColors.js';
import companyDeterminationStatus from '@/utils/constants/companyDeterminationStatus.js';
import companyDeterminationStatusColors from '@/utils/constants/companyDeterminationStatusColors.js';
import { IP_API_URL } from '@/config';

import moment from 'moment';
import axios from 'axios';

const utils = {
  convertToBlob(documentFile) {
    const blob = this.getBlobConvertion(documentFile);

    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = documentFile.filename;
    link.click();
  },
  convertToBlobWindow(documentFile) {
    const blob = this.getBlobConvertion(documentFile);
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank');
  },
  getBlobConvertion(documentFile) {
    const byteArray = this.convertToByteArray(documentFile.content);
    return new Blob([byteArray], {
      type: documentFile.contentType,
    });
  },
  convertToByteArray(documentContent) {
    const byteChars = atob(documentContent);
    const byteNumbers = new Array(byteChars.length);
    for (let i = 0; i < byteChars.length; i++) {
      byteNumbers[i] = byteChars.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    return byteArray;
  },
  parseStateColorBillingByStatus(billingStatusId) {
    switch (billingStatusId) {
      case billingStatus.Preliminar:
        return billingStatusColor.Gray;
      case billingStatus.PendienteIntervencion:
      case billingStatus.PendienteInformacion:
      case billingStatus.EnProcesoIntervencion:
      case billingStatus.PendienteRevision:
      case billingStatus.PendienteAprobacion:
      case billingStatus.PreAprobado:
      case billingStatus.EnProcesoDeAjuste:
      case billingStatus.Sometida:
        return billingStatusColor.Yellow;
      case billingStatus.EnProcesoIntervencionObjetada:
      case billingStatus.PendienteIntervencionObjetada:
        return billingStatusColor.Violet;
      case billingStatus.Aprobado:
      case billingStatus.Pagado:
      case billingStatus.EnProcesoPago:
        return 'green-light-1';
      case billingStatus.DevueltoTPFA:
        return billingStatusColor.Brown;
      case billingStatus.EnviadoFinanzas:
      case billingStatus.EnviadoFinanzasParcial:
        return billingStatusColor.OrangeLight;
      case billingStatus.Cancelada:
        return billingStatusColor.Brown;
      default:
        return '';
    }
  },
  parseStateColorCertificationByStatus(certificationStatusId) {
    switch (certificationStatusId) {
      case CertificationStatus.Pending:
        return CertificationStatusColors.Yellow;
      case CertificationStatus.Uploaded:
        return CertificationStatusColors.GreenLight;
      default:
        return '';
    }
  },
  validateIsSunday(year, month, day) {
    if (year && month && day) {
      const visitDate = new Date(year, month, day);
      return visitDate.getDay() === 0;
    }
    return false;
  },
  validateIsSameOrAfterDate(fromDate, toDate) {
    const from = moment(fromDate, 'YYYY-MM-DD');
    const to = moment(toDate, 'YYYY-MM-DD');
    return to.isSameOrAfter(from);
  },
  parseStateColorProviderApprovalByStatus(companyDeterminationStatusId) {
    switch (companyDeterminationStatusId) {
      case companyDeterminationStatus.Nuevo:
        return companyDeterminationStatusColors.Gray;
      case companyDeterminationStatus.Aprobado:
        return companyDeterminationStatusColors.GreenLight;
      case companyDeterminationStatus.Denegado:
        return companyDeterminationStatusColors.Red;
      case companyDeterminationStatus.DocumentosSometidos:
        return companyDeterminationStatusColors.Yellow;
      default:
        return '';
    }
  },
  async getPublicIP() {
    var ip = '';
    await axios.get(IP_API_URL).then((response) => {
      if (response?.data?.ip) {
        ip = response.data.ip;
      }
    });
    return ip;
  },
};

export default utils;
